import { http } from '@/core/api/';
const apiUrl = 'api/visitregistryeducational';

export const getInitFilters = () => {
  return http.get(`${apiUrl}/initfilters`);
};

export const getMonths = (academicYearId) => {
  return http.get(`${apiUrl}/months/${academicYearId}`);
};

export const getProviders = (
  academicYearId,
  monthDate,
  shouldCallDeProviderOnly
) => {
  return http.get(`${apiUrl}/providers/${academicYearId}`, {
    params: {
      shouldCallDeProviderOnly,
      monthDate,
    },
  });
};

export const getSpecialists = (
  academicYearId,
  monthDate,
  providerId,
  locationFiscalYearId
) => {
  return http.get(`${apiUrl}/specialists/${academicYearId}`, {
    params: {
      monthDate,
      providerId,
      locationFiscalYearId,
    },
  });
};

export const getCenters = (
  academicYearId,
  monthDate,
  providerId,
  specialistId
) => {
  return http.get(`${apiUrl}/centers/${academicYearId}`, {
    params: {
      monthDate,
      providerId,
      specialistId,
    },
  });
};

export const getServices = (monthDate, providerId, specialistId) => {
  return http.get(`${apiUrl}/services`, {
    params: {
      monthDate,
      providerId,
      specialistId,
    },
  });
};

export const getLocations = (
  academicYearId,
  providerId,
  specialistId,
  locationTypeId
) => {
  return http.get(`${apiUrl}/locations`, {
    params: {
      academicYearId,
      providerId,
      specialistId,
      locationTypeId,
    },
  });
};

export const searchVisits = (payload, pageIndex = 1, pageSize = 15) => {
  return http.get(`${apiUrl}/search`, {
    params: {
      ...payload,
      pageIndex,
      pageSize,
    },
  });
};

export const getVisitTypes = () => {
  return http.get(`${apiUrl}/visittypes`);
};

export const getVisits = (studentSieId, periodAcademicYear, monthNumber) => {
  return http.get(`${apiUrl}/visits`, {
    params: {
      studentSieId,
      periodAcademicYear,
      monthNumber,
    },
  });
};

export const saveVisit = (payload) => {
  return http.post(`${apiUrl}/savevisit`, payload);
};

export const deleteVisit = (visitId) => {
  return http.delete(`${apiUrl}/visit/${visitId}`);
};

export const getIsFinalizedPeriod = (payload) => {
  return http.get(`${apiUrl}/isfinalizedperiod`, {
    params: {
      ...payload,
    },
  });
};

export const getAcademicYearsAndCompensatoryNumbers = (
  studentSieId,
  disciplineTypeId
) => {
  return http.get(
    `${apiUrl}/academicyearsandcompensatorynumbers/${studentSieId}/${disciplineTypeId}`
  );
};

export const getRequestDetails = (studentSieId) => {
  return http.get(`${apiUrl}/requestdetails/${studentSieId}`);
};

export const checkForExtendedAcademicYearSchool = (
  academicYearId,
  studentSieId,
  disciplineTypeId
) => {
  return http.get(
    `${apiUrl}/checkforextendedacademicyearschool/${academicYearId}/${studentSieId}/${disciplineTypeId}`
  );
};

export const getStudentInfoEducationalCompensatoryRequest = (studentSieId) => {
  return http.get(
    `${apiUrl}/studentinfoeducationalcompensatoryrequest/${studentSieId}`
  );
};
